import React, { Fragment } from 'react';

const HeadersUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Headers are contextual and provide quick navigation through the product.
          </h1>
        </div>
        <div className="right">
          <p>Headers help users identify where they are and provide a quick, organized way to reach the main sections of a product. The headers include branding to identify the product and are composed of different and independent elements, that adapt to the needed context.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Standard Headers</h2>
          <p>The standard header is, by default, composed by the container, logo, and divider. The component has some variations with some sections being active, or inactive depending on the page the user is, these sections are: billable ID menu, action icons, and links.</p>
          <h2 className="h2 page-subtitle">Status Pages Headers</h2>
          <p>The status page headers are a variation of the standard header. Besides the default elements, there are also three action icons: mail, print, and download. Depending on the page the user is, some of them might not be shown.</p>
          <h2 className="h2 page-subtitle">Landing Pages Headers</h2>
          <p>These headers are used in landing pages and have two levels of information. The first level, when active, is a menu section, and the second is composed by the logo, a bigger menu section and also action icons.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default HeadersUsage;


// WEBPACK FOOTER //
// ./src/containers/components/Header/HeadersUsage.js